import React from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useLang } from "../i18n/LanguageContext";
import { Compass, Ruler, Hammer, Truck, Wrench, Accessibility } from "lucide-react";

const ICONS = [Compass, Ruler, Hammer, Truck, Wrench, Accessibility];

export const Services = ({ hideHeader = false }) => {
  const { t } = useLang();
  const items = t("services.items") || [];

  return (
    <section id="services" className="relative py-24 lg:py-32 bg-[#F9F8F6]" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        {!hideHeader && (
        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#8A5A44] mb-5"
            data-testid="services-eyebrow"
          >
            — {t("services.eyebrow")}
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[0.95]"
            data-testid="services-title"
          >
            {t("services.title")}
          </motion.h2>
        </div>
        )}

        <div className={hideHeader ? "lg:col-span-12" : "lg:col-span-7"}>
          <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
            {items.map((it, i) => {
              const Icon = ICONS[i] || Compass;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.05 }}
                >
                  <AccordionItem value={`item-${i}`} className="border-b border-[#DCD7D1]" data-testid={`service-item-${i}`}>
                    <AccordionTrigger className="py-6 hover:no-underline group">
                      <div className="flex items-center gap-5 text-left">
                        <span className="text-xs tracking-[0.2em] uppercase text-[#8A5A44] tabular w-10">0{i + 1}</span>
                        <Icon size={22} strokeWidth={1.4} className="text-[#1A1A1A]" />
                        <span className="font-display text-2xl lg:text-3xl font-light tracking-tight">{it.name}</span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="text-[#4A4A4A] text-base leading-relaxed pb-8 pl-[3.75rem] lg:pl-[5.5rem] max-w-2xl">
                      {it.desc}
                    </AccordionContent>
                  </AccordionItem>
                </motion.div>
              );
            })}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
